import { render, staticRenderFns } from "./WidgetSettingsTypes.vue?vue&type=template&id=0f0652b8&"
import script from "./WidgetSettingsTypes.vue?vue&type=script&lang=js&"
export * from "./WidgetSettingsTypes.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSettingsTypes.vue?vue&type=style&index=0&id=0f0652b8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "general/lang/WidgetSettingsTypes.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Freleases%2Ffront%2Ffront_131%2Fsrc%2Fbc%2Fcomponents%2FWidgetSettings%2FWidgetSettingsTypes.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports